import React from 'react';
import { LaunchStrategyRecommendation, useLaunchStrategyContext, } from '@modules/Dashboard/modules/LaunchStrategy';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
export const useLaunchStrategyRecommendation = () => {
    const { createOnDismiss } = useRecommendationsDismiss();
    const { data: launchStrategyData, visible: launchStrategyVisible, openModal: openLaunchStrategyModal, onDismiss: onLaunchStrategyDismiss, } = useLaunchStrategyContext();
    return {
        launchStrategyRecommendation: {
            id: 'launchStrategy',
            enabled: launchStrategyVisible,
            isLoading: false,
            suggestion: (React.createElement(LaunchStrategyRecommendation, { ...launchStrategyData.recommendation, onClick: openLaunchStrategyModal, onDismiss: createOnDismiss(onLaunchStrategyDismiss) })),
        },
    };
};
